import React from 'react';

import {
  AdaptiveCarouselImage,
  AdaptiveCarouselSlidePickerThumbnail,
  AdaptiveCarouselSlidePickerThumbnails,
} from '@vp/swan';
import { useLocalizations } from '@vp/ubik-localizations-provider';

import { sendMediaEngaged } from '../../../infrastructure/clients/trackingClient';
import { Slide } from '../domain/Slide';
import { SlideArray } from '../domain/SlideArray';
import { buildKeyboardEventHandler } from '../libs/keyboardEventHandlerBuilder';

interface ThumbnailsProps {
  mediaArray: SlideArray;
  mpvId: string;
  productKey: string;
}
export const Thumbnails: React.FC<ThumbnailsProps> = (props) => {
  const { t } = useLocalizations();
  if (props.mediaArray.all.length <= 1) {
    return null;
  }
  const sliderPicker = props.mediaArray.all.map((slide: Slide) => {
    const slideProps = slide.isVideo ? { video: true } : {};
    return (
      <AdaptiveCarouselSlidePickerThumbnail
        key={slide.thumbnailId}
        {...slideProps}
        onClick={() => sendMediaEngaged(slide.position, props.mpvId, props.productKey)}
        onKeyDown={buildKeyboardEventHandler(() =>
          sendMediaEngaged(slide.position, props.mpvId, props.productKey)
        )}
      >
        <AdaptiveCarouselImage
          src={slide.thumbnail}
          alt={slide.getAlt(t)}
          aspectRatio={'1'}
          objectFit="contain"
        />
      </AdaptiveCarouselSlidePickerThumbnail>
    );
  });

  return (
    <AdaptiveCarouselSlidePickerThumbnails>{sliderPicker}</AdaptiveCarouselSlidePickerThumbnails>
  );
};
